<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div class="page-heading d-flex align-items-center">
        <img
          src="../../assets/bckarrow.svg"
          class="pointer"
          alt=""
          @click="gotodashboard"
        />
        <div class="main-head ml-4">
          <span>Send Appointment Letter</span>
        </div>
      </div>
      <div class="viewopsheadjdcontainer mt-2">
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="search-bar" style="width: 65%">
            <img
              class="searchicon"
              src="../../assets/img/search-bar-icon.svg"
              alt=""
            />

            <b-form-input
              type="search"
              class="search-input"
              placeholder="Search candidate"
              v-model.trim="searchQuery"
              @keyup="textSearch()"
            ></b-form-input>
          </div>
        </div>
        <div class="tabbed sendappoint mt-3">
          <!-- table starts -->
          <b-tabs v-model="tabIndex">
            <b-tab
              title="Send Appointment"
              @click="
                getAppointCandidates(
                  (status = '8'),
                  (page = 1),
                  (goToPage = null)
                )
              "
            >
              <div>
                <!-- table starts -->
                <div class="table-main">
                  <table
                    class="
                      w-100
                      table-design
                      opshead-approve-head
                      jdtablecontent
                    "
                    :aria-describedby="'Send appointment'"
                  >
                    <thead>
                      <tr>
                        <th style="width: 15%">
                          <span class="pl-4">Candidate Name</span>
                          <template v-if="statusValue == 'customerName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = 1);
                                getAppointCandidates();
                              "
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = -1);
                                getAppointCandidates();
                              "
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer ml-2"
                            v-else
                            @click="
                              (filter = true),
                                (statusValue = 'customerName'),
                                (sortByValue = true),
                                (order = 1),
                                getAppointCandidates()
                            "
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </th>
                        <th style="width: 20%" class="text-center">
                          <span>Email</span>
                          <template v-if="statusValue == 'email'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'email'),
                                  (order = 1),
                                  getAppointCandidates()
                              "
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'email'),
                                  (order = -1),
                                  getAppointCandidates()
                              "
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer ml-2"
                            v-else
                            @click="
                              (filter = true),
                                (statusValue = 'email'),
                                (sortByValue = true),
                                (order = 1),
                                getAppointCandidates()
                            "
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </th>
                        <th style="width: 10%" class="text-center">
                          <span>Date of joining</span>
                        </th>
                        <th style="width: 10%" class="text-center">
                          <span>Department</span>
                        </th>

                        <th style="width: 10%" class="text-center">
                          <span>Designation</span>
                        </th>

                        <th style="width: 10%" class="text-center">
                          <span>Candidate CTC</span>
                        </th>

                        <th style="width: 7%" class="text-center">
                          <span>Current status</span>
                        </th>
                        <th style="width: 15%" class="text-center">
                          <span>Action</span>
                        </th>

                        <th style="width: 5%"></th>
                      </tr>
                    </thead>

                    <tbody v-if="appointCandidates.length > 0">
                      <tr
                        v-for="(candidate, index) in appointCandidates"
                        class="selected-table-cards"
                        :key="index"
                      >
                        <td style="width: 15%">
                          <span
                            :style="{
                              background:
                                '#' + Math.random().toString(16).slice(-6),
                            }"
                            class="gridgreencolorDynamic mr-1"
                          ></span>
                          <span class="ml-3">
                            {{
                              `${candidate.firstName} ${candidate.middleName} ${candidate.lastName}`
                            }}
                          </span>
                        </td>

                        <td style="width: 20%" class="text-center">
                          {{ candidate.email }}
                        </td>

                        <td style="width: 10%" class="text-center">
                          {{ candidate.dateOfJoining.slice(0, 10) }}
                        </td>

                        <td style="width: 10%" class="text-center">
                          {{ candidate.department }}
                        </td>

                        <td style="width: 10%" class="text-center">
                          {{ candidate.designation }}
                        </td>

                        <td style="width: 10%" class="text-center">
                          {{ candidate.offeredCTC }}
                        </td>

                        <td style="width: 7%" class="text-center">Appointed</td>
                        <td style="width: 15%" class="text-center">
                          <b-button
                            class="addbtn pt-1 pb-1 pr-3 pl-3"
                            @click="
                              (selectedCandidate = candidate),
                                $bvModal.show('onboard')
                            "
                          >
                            Onboard Candidate
                          </b-button>
                        </td>
                        <td style="width: 5%" class="text-right">
                          <div class="d-flex align-items-center">
                            <div
                              class="p-2 mr-1"
                              @click="
                                goToCandidateDetails(candidate.RecCandidateID)
                              "
                            >
                              <img
                                src="../../assets/eyeicon.svg"
                                class="pointer"
                                alt=""
                              />
                            </div>
                            <div class="viewmore-parent">
                              <div
                                class="pointer"
                                :id="candidate.RecCandidateID"
                              >
                                <img
                                  src="../../assets/img/hrportal/viewmore.svg"
                                  alt=""
                                />
                              </div>
                              <b-popover
                                :target="candidate.RecCandidateID"
                                triggers="hover"
                                placement="bottomleft"
                              >
                                <div
                                  @click="openNotInterested(candidate)"
                                  class="hr-nibox pointer"
                                >
                                  Not Interested
                                </div>
                              </b-popover>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-else>
                      <tr>
                        <td class="text-center">No Records Found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-tab>

            <b-tab
              title="On Boarded"
              @click="
                getAppointCandidates(
                  (status = '9'),
                  (page = 1),
                  (goToPage = null)
                )
              "
            >
              <div>
                <!-- table starts -->
                <div class="table-main">
                  <table
                    class="
                      w-100
                      table-design
                      opshead-approve-head
                      jdtablecontent
                    "
                    :aria-describedby="'On boarded'"
                  >
                    <thead>
                      <tr>
                        <th style="width: 20%">
                          <span class="pl-4">Candidate Name</span>
                          <template v-if="statusValue == 'customerName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = 1);
                                getAppointCandidates();
                              "
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = -1);
                                getAppointCandidates();
                              "
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer ml-2"
                            v-else
                            @click="
                              (filter = true),
                                (statusValue = 'customerName'),
                                (sortByValue = true),
                                (order = 1),
                                getAppointCandidates()
                            "
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </th>
                        <th style="width: 25%" class="text-center">
                          <span>Email</span>
                          <template v-if="statusValue == 'email'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'email'),
                                  (order = 1),
                                  getAppointCandidates()
                              "
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'email'),
                                  (order = -1),
                                  getAppointCandidates()
                              "
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer ml-2"
                            v-else
                            @click="
                              (filter = true),
                                (statusValue = 'email'),
                                (sortByValue = true),
                                (order = 1),
                                getAppointCandidates()
                            "
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </th>

                        <th style="width: 10%" class="text-center">
                          <span>Date of joining</span>
                        </th>

                        <th style="width: 10%" class="text-center">
                          <span>Department</span>
                        </th>

                        <th style="width: 15%" class="text-center">
                          <span>Designation</span>
                        </th>

                        <th style="width: 10%" class="text-center">
                          <span>Candidate CTC</span>
                        </th>

                        <th style="width: 10%" class="text-center">
                          <span>Current status</span>
                        </th>

                        <th style="width: 5%"></th>
                      </tr>
                    </thead>

                    <tbody v-if="appointCandidates.length > 0">
                      <tr
                        v-for="(candidate, index) in appointCandidates"
                        class="selected-table-cards"
                        :key="index"
                      >
                        <td style="width: 20%">
                          <span
                            :style="{
                              background:
                                '#' + Math.random().toString(16).slice(-6),
                            }"
                            class="gridgreencolorDynamic mr-1"
                          ></span>
                          <span class="ml-3">
                            {{
                              `${candidate.firstName} ${candidate.middleName} ${candidate.lastName}`
                            }}
                          </span>
                        </td>
                        <td style="width: 25%" class="text-center">
                          {{ candidate.email }}
                        </td>

                        <td style="width: 10%" class="text-center">
                          {{ candidate.dateOfJoining.slice(0, 10) }}
                        </td>

                        <td style="width: 10%" class="text-center">
                          {{ candidate.department }}
                        </td>

                        <td style="width: 15%" class="text-center">
                          {{ candidate.designation }}
                        </td>

                        <td style="width: 10%" class="text-center">
                          {{ candidate.offeredCTC }}
                        </td>

                        <td style="width: 10%" class="text-right">
                          <div class="onboarded p-2 text-center">
                            On Boarded
                          </div>
                        </td>

                        <td style="width: 5%" class="text-center">
                          <div
                            class="p-2 mr-1"
                            @click="
                              goToCandidateDetails(candidate.RecCandidateID)
                            "
                          >
                            <img
                              src="../../assets/eyeicon.svg"
                              class="pointer"
                              alt=""
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center">No Records Found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-tab>
          </b-tabs>

          <!-- table ends -->
          <div
            class="paginaTion d-flex justify-content-between align-items-center"
          >
            <div class="d-flex">
              <span class="qb-gotopage-text p-1">Go to page</span>
              <b-form-input
                type="text"
                class="qb-pagination-num mr-1"
                v-model="goToPage"
                @keyup.enter="
                  goToPage === null || goToPage == '' || iscontainsNumber
                    ? ''
                    : gotopgnum(goToPage)
                "
              ></b-form-input>
              <b-button
                class="qb-pagination-addbtn"
                @click="gotopgnum(goToPage)"
                :disabled="
                  goToPage === null || goToPage == '' || iscontainsNumber
                "
              >
                <span
                  ><img src="../../assets/whiterightarrow.svg" alt=""
                /></span>
              </b-button>
            </div>
            <div class="pagination">
              <b-pagination
                v-model="page"
                @input="getAppointCandidates()"
                :total-rows="total"
                :per-page="count"
                align="center"
                first-number
                last-number
              >
                <template #prev-text
                  ><span><img src="../../assets/leftvector.svg" alt="" /> </span
                ></template>
                <template #next-text
                  ><span><img src="../../assets/rightarrow.svg" alt="" /></span
                ></template>
              </b-pagination>
            </div>
            <div class="qb-gotopage-text mr-2">
              Results : <span v-if="pageStart > total">0</span
              ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
              <span class="pl-1"></span> of <span class="pr-1"></span
              >{{ total }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="not-interested"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
      :no-close-on-backdrop="true"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
        style="color: #545454"
      >
        Confirmation
      </div>
      <hr />
      <div @click="$bvModal.hide('not-interested')" class="xMarkCancel">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <div>
        <div class="modal-text">
          Do you want to move
          <span class="options-text"
            >&ldquo;{{ selectedCandidate.email }}&ldquo;</span
          >
          to uninterested?
        </div>
        <div class="topDiv mt-4">
          <label class="fieldsetStyle">Remarks</label>
          <b-form-textarea
            class="inputField"
            id="input-1"
            type="text"
            rows="3"
            max-rows="6"
            placeholder="Enter Remarks"
            v-model="niremarks"
          >
          </b-form-textarea>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <div
            class="cancelbtntext pointer mr-4"
            @click="$bvModal.hide('not-interested')"
          >
            Cancel
          </div>
          <b-button class="addbtn pr-4 pl-4" @click="makeNotInterested"
            >OK</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      id="onboard"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
      :no-close-on-backdrop="true"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
        style="color: #545454"
      >
        Confirmation
      </div>
      <hr />
      <div @click="$bvModal.hide('onboard')" class="xMarkCancel">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <div>
        <div class="modal-text">
          Do you want to move
          <span class="options-text"
            >&ldquo;{{ selectedCandidate.email }}&ldquo;</span
          >
          to onboarded?
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <div
            class="cancelbtntext pointer mr-4"
            @click="$bvModal.hide('onboard')"
          >
            Cancel
          </div>
          <b-button class="addbtn pr-4 pl-4" @click="onboardCandidate()"
            >OK</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  getOfferInitializePagination,
  setNotInterested,
  onboardCandidate,
} from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import toast from "../../components/mixin/toast";
export default {
  components: {
    Spinner,
  },
  mixins: [toast],

  data() {
    return {
      // NUMBER
      totalPages: null,
      tabIndex: 0,
      count: 50,
      page: 1,
      goToPage: null,
      total: null,
      pageStart: null,
      pageEnd: null,
      timer: null,

      //STRINGS
      niremarks: "",
      statusValue: "",
      actionList: "",
      searchQuery: "",
      sortBy: "updatedAt",
      status: "8",
      order: "-1",

      // BOOLEAN
      LoaderStatus: false,
      filter: false,
      sortByValue: false,

      // OBJECTS
      selectedCandidate: {},

      //ARRAYS
      appointCandidates: [],
    };
  },
  computed: {
    iscontainsNumber() {
      return !/^[1-9]\d*$/.test(this.goToPage);
    },
  },
  created() {
    this.getAppointCandidates();
  },
  methods: {
    // search function
    textSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.page = 1;
        this.getAppointCandidates();
      }, 400);
    },

    // Go to selected Page
    gotopgnum(index) {
      if (index > 0) {
        this.page = Math.min(Math.max(1, index), this.totalPages);
        this.getAppointCandidates();
      }
      this.goToPage = null;
    },

    // OPEN NOT INTERESTED MODDL
    openNotInterested(candidate) {
      this.selectedCandidate = candidate;
      this.$bvModal.show("not-interested");
    },

    // ASYNCHRONOUS FUNCTIONS ----- START

    // GET APPOINTED CANDIDATES
    async getAppointCandidates() {
      this.LoaderStatus = true;
      try {
        let payload = {
          sortBy: this.sortBy,
          order: this.order,
          count: this.count,
          status: this.status,
          actionList: this.actionList,
          searchQuery: this.searchQuery,
          page: this.page - 1,
        };

        const response = await getOfferInitializePagination(payload);
        this.appointCandidates = response.data.data.data;
        this.total = response.data.data.total;
        this.pageStart = response.data.data.pageStart;
        this.pageEnd = response.data.data.pageEnd;
        this.totalPages = Math.ceil(
          parseInt(this.total) / parseInt(this.count)
        );
        this.LoaderStatus = false;
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(
          `Failed! getAppointCandidates ! status: ${error.status}`
        );
      }
    },

    // MAKE CANDIDATE AS NOT INTERESTED
    async makeNotInterested() {
      try {
        let payload = {
          candidateID: this.selectedCandidate.RecCandidateID,
          remarks: this.niremarks,
        };
        const response = await setNotInterested(payload);
        if (response.status == 200) {
          this.getAppointCandidates();
          this.$bvModal.hide("not-interested");
          this.successModal("Candidate moved to not interested");
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
        throw new Error(`Failed! makeNotInterested ! status: ${error.status}`);
      }
    },

    // ASYNCHRONOUS FUNCTIONS ----- END

    // HELPER FUNCTIONS FOR NAVIGATIONS ---START
    goToCandidateDetails(data) {
      this.$router.push({
        name: "CandidateDetails",
        params: {
          candidateID: data,
        },
        query: {
          redirect: this.$route.name,
        },
      });
    },
    gotodashboard() {
      this.$router.push({
        name: "Dashboard",
      });
    },
    async onboardCandidate() {
      try {
        let payload = {
          candidateID: this.selectedCandidate.RecCandidateID,
        };
        const res = await onboardCandidate(payload);
        if (res.status == 200) {
          this.successModal(
            `${this.selectedCandidate.email} onboarded successfully`
          );
        } else {
          this.errorModal("Something went wrong");
        }

        this.getAppointCandidates();
        this.$bvModal.hide("onboard");
      } catch (error) {
        throw new Error(`Failed! onboardCandidate ! status: ${error.status}`);
      }
    },
    ViewOnboardingCandidate(id) {
      this.$router.push({
        name: "AppointmentLetter",
        params: {
          candidateID: id,
        },
        query: {
          redirect: "SendAppointment",
        },
      });
    },
    // HELPER FUNCTIONS FOR NAVIGATIONS ---END
  },
};
</script>

<style>
.hr-nibox {
  padding: 10px;
  background-color: #f4f4f4;
  border-radius: 5px;
  font-weight: 400;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #545454;
}
.selected-table-cards:hover {
  background: #e7e8f5;
}

.tp-reports-table tbody tr {
  height: 50px;
  border: 0.5px solid #e5e5e5;
  box-sizing: border-box;
  background: #fcfcfc;
  box-shadow: 0px 4px 12px rgba(196, 196, 196, 0.5);
  margin: 8px 0px 8px 0px;
  width: 99.5%;
  display: table;
  border-radius: 3px;
  table-layout: fixed;
}

.candidate-row {
  width: 15%;
  text-align: left;
}
</style>

<style>
.viewopsheadjdcontainer {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  height: calc(100vh - 150px);
  padding: 15px;
}
.sendappoint ul li a {
  width: 210px !important;
}
.onboarded {
  background: #18a41d;
  border-radius: 5px;
  color: #ffffff;
  font-weight: 500;
  cursor: default;
}
</style>
